<form
    (submit)="update()"
    [formGroup]="form"
    class="d-flex flex-column flex-fill"
    novalidate
>
  <div class="modal-header align-items-center">
    <h4 class="modal-title pull-left">{{ 'Payment.update-payment-method' | translate }}</h4>
    <button (click)="bsModalRef.hide()" class="text-muted">
      <svg class="icon" viewBox="0 0 24 24">
        <path
            d="M13.46,12L19,17.54V19H17.54L12,13.46L6.46,19H5V17.54L10.54,12L5,6.46V5H6.46L12,10.54L17.54,5H19V6.46L13.46,12Z"
            stroke="none"
        />
      </svg>
    </button>
  </div>

  <div class="scrollable scrollable-y">
    <div class="scrollable-main">
      <div class="scrollable-content">
        <div class="modal-body">
          <div class="form-group">
            <label class="small font-weight-medium text-muted text-uppercase" for="name">
              {{ 'Payment.name' | translate }} <span class="text-danger pl-1">*</span>
            </label>
            <input [attr.aria-invalid]="form.controls['name']?.invalid && (form.controls['name']?.dirty || form.controls['name']?.touched || form.controls['name'].errors) ? 'true' : 'false'"
                [attr.aria-label]="'Payment.name' | translate"
                [attr.aria-required]="'true'"
                [ngClass]="{
                        'is-invalid':
                          form.controls['name']?.touched &&
                          form.controls['name'].errors
                      }"
                class="form-control"
                formControlName="name"
                id="name"
                type="text"
            />
          </div>
          <div class="form-group">
            <div class="form-group pl-4">
              <input
                  [attr.aria-label]="'Payment.default-payment-method' | translate"
                  class="custom-control-input"
                  formControlName="isDefault"
                  id="defaultPaymentMethod"
                  type="checkbox"
              />
              <label class="custom-control-label" for="defaultPaymentMethod">
                {{ 'Payment.default-payment-method' | translate }}
              </label>
            </div>
          </div>
          <tabset type="tabs nav-tabs-line nav-fill">
            <tab [active]="paymentMethod.type === 'ach'" [disabled]="paymentMethod.type !== 'ach'">
              <ng-template tabHeading>
                <span class="font-weight-medium text-uppercase">ACH</span>
              </ng-template>
              <div class="card border-top-0">
                <div class="p-3">
                  <div id="bank">
                    <div class="row">
                      <div class="col-12 col-md-6">
                        <!-- ui-mask-show maskChar="*" -->
                        <div class="form-group">
                          <label class="font-weight-600" for="routingNumber">
                            {{ "CommonForm.routing-number-label" | translate }}
                            <span class="text-danger pl-1">*</span>
                          </label>
                          <div class="input-group" formGroupName="bank">
                            <input (change)="strip(form.get('bank.routingNumber'))"
                                (displayCounter)="displayCounter($event, 'bank.routingNumber')"
                                (keypress)="onlyNumberKey($event)"
                                [attr.aria-invalid]="form.get('bank.routingNumber').invalid && (form.get('bank.routingNumber').dirty || form.get('bank.routingNumber').touched) ? 'true' : 'false'"
                                [attr.aria-label]="'CommonForm.routing-number-label' | translate"
                                [attr.aria-required]="'true'"
                                [class.is-invalid]="form.get('bank.routingNumber').invalid && (form.get('bank.routingNumber').dirty || form.get('bank.routingNumber').touched)"
                                class="form-control"
                                formControlName="routingNumber"
                                id="routingNumber"
                                maskChar="*"
                                type="text"
                                ui-mask-show/>
                          </div>
                          <div *ngIf="form.get('bank.routingNumber').touched && form.get('bank.routingNumber').errors" class="invalid-feedback" style="display: block">
                            <div *ngIf="form.get('bank.routingNumber').errors['required'] ||form.get('bank.routingNumber').errors['pattern']">
                              {{ "CommonForm.routing-number-required"| translate }}
                            </div>
                            <div *ngIf="form.get('bank.routingNumber').errors['mustMatch']">
                              {{ "CommonForm.routing-number-not-valid"| translate }}
                            </div>
                            <div *ngIf="form.get('bank.routingNumber').errors['invalidRoutingNumber'] || form.get('bank.routingNumber').errors['lengthError'] ">
                              {{ "CommonForm.routing-number-not-valid"| translate }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <label class="font-weight-600" for="confirmRoutingNumber">{{ "CommonForm.confirm-routing-number" | translate }}
                            <span class="text-danger pl-1">*</span></label>
                          <div class="input-group">
                            <input (change)="strip(form.get('confirmRoutingNumber'))"
                                (displayCounter)="displayCounter($event, 'confirmRoutingNumber')"
                                (keypress)="onlyNumberKey($event)"
                                [attr.aria-label]="'CommonForm.confirm-routing-number' | translate"
                                [attr.aria-required]="'true'"
                                class="form-control"
                                formControlName="confirmRoutingNumber"
                                id="confirmRoutingNumber"
                                maskChar="*"
                                type="text"
                                ui-mask-show
                            />
                          </div>

                          <div *ngIf="form.get('confirmRoutingNumber').touched && form.get('confirmRoutingNumber').errors" class="invalid-feedback" style="display: block">
                            <div *ngIf="form.get('confirmRoutingNumber').errors['required']">
                              {{ "CommonForm.routing-number-required"| translate }}
                            </div>
                            <div *ngIf="form.get('confirmRoutingNumber').errors['mustMatch']">
                              {{ "CommonForm.routing-number-not-valid"| translate }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <label class="font-weight-600" for="accountNumber">
                            {{ "CommonForm.account-number-label" | translate }}
                          </label><span class="text-danger pl-1">*</span>
                          <div class="input-group" formGroupName="bank">
                            <input (change)="strip(form.get('bank.accountNumber'))"
                                (displayCounter)="displayCounter($event, 'bank.accountNumber')"
                                (keypress)="onlyNumberKey($event)"
                                [attr.aria-invalid]="form.get('bank.accountNumber').invalid && (form.get('bank.accountNumber').dirty || form.get('bank.accountNumber').touched) ? 'true' : 'false'"
                                [attr.aria-label]="'CommonForm.account-number-label' | translate"
                                [attr.aria-required]="'true'"
                                [class.is-invalid]=" form.get('bank.accountNumber').invalid && (form.get('bank.accountNumber').dirty || form.get('bank.accountNumber').touched)"
                                class="form-control"
                                formControlName="accountNumber"
                                id="accountNumber"
                                maskChar="*"
                                type="text"
                                ui-mask-show
                            />
                          </div>
                          <div *ngIf="form.get('bank.accountNumber').touched && form.get('bank.accountNumber').errors " class="invalid-feedback" style="display: block">
                            <div *ngIf="form.get('bank.accountNumber').errors['required']">
                              {{ "CommonForm.account-number-required"| translate }}
                            </div>
                            <div *ngIf="form.get('bank.accountNumber').errors[ 'mustMatch'  ] || form.get('bank.accountNumber').errors['pattern']">
                              {{ "CommonForm.account-number-not-valid"| translate }}
                            </div>
                            <div *ngIf="form.get('bank.accountNumber').errors['invalidAccountNumber'] || form.get('bank.accountNumber').errors['lengthError']">
                              {{ "CommonForm.account-number-not-valid"| translate }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <label class="font-weight-600" for="confirmAccountNumber">
                            {{ "CommonForm.confirm-account-number-label"| translate }}
                          </label> <span class="text-danger pl-1">*</span>
                          <div class="input-group">
                            <input
                                (change)="strip(form.get('confirmAccountNumber'))"
                                (displayCounter)="displayCounter($event, 'confirmAccountNumber')"
                                (keypress)="onlyNumberKey($event)"
                                [attr.aria-label]="'CommonForm.confirm-account-number-label' | translate"
                                [attr.aria-required]="'true'"
                                class="form-control"
                                formControlName="confirmAccountNumber"
                                id="confirmAccountNumber"
                                maskChar="*"
                                type="text"
                                ui-mask-show
                            />
                          </div>

                          <div *ngIf="form.get('confirmAccountNumber').touched && form.get('confirmAccountNumber').errors"
                              class="invalid-feedback"
                              style="display: block">
                            <div *ngIf="form.get('confirmAccountNumber').errors['required']">
                              {{ "CommonForm.account-number-required"| translate }}
                            </div>
                            <div *ngIf="form.get('confirmAccountNumber').errors['mustMatch']">
                              {{ "CommonForm.account-number-not-valid"| translate }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group" formGroupName="bank">
                      <label for="accountType">{{ "CommonForm.account-type-label" | translate }} <span class="text-danger pl-1">*</span></label>
                      <label *ngFor="let rad of accountType" class="radio-inline"
                          for="accountType-{{rad.value}}">
                        <input [attr.aria-invalid]="form.get('bank.accountType')?.invalid && (form.get('bank.accountType')?.dirty || form.get('bank.accountType')?.touched) ? 'true' : 'false'"
                            [attr.aria-label]="'rad.label' | translate"
                            [attr.aria-required]="'true'"
                            [class.is-invalid]=" form.get('bank.accountType')?.invalid &&(form.get('bank.accountType')?.dirty ||form.get('bank.accountType')?.touched)"
                            class="radio m-1 text-sm-start"
                            formControlName="accountType"
                            id="accountType-{{rad.value}}"
                            name="accountType"
                            type="radio"
                            value="{{ rad.value }}"
                        />{{ rad.label | translate }}
                      </label>
                      <div *ngIf="form.get('bank.accountType').touched &&form.get('bank.accountType').errors"
                          class="invalid-feedback"
                          style="display: block">
                        <div *ngIf="form.get('bank.accountType').errors['required']">
                          {{ 'Payment.account-type-required' | translate }}
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <span class="small font-weight-medium text-muted text-uppercase">
                          {{ "PaymentPage.payment-note" | translate }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </tab>
            <tab [active]="paymentMethod.type === 'card' || paymentMethod.type === 'bank'" [disabled]="paymentMethod.type !== 'card'">
              <ng-template tabHeading>
                <span class="font-weight-medium text-uppercase">{{ 'Payment.credit-card' | translate }}</span>
              </ng-template>
              <div class="d-flex align-items-center justify-content-center">
                <city-tax-card-details *ngIf="paymentMethod" [selectedPaymentMethod]="paymentMethod"></city-tax-card-details>
              </div>
            </tab>
          </tabset>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer justify-content-end">
    <button (click)="bsModalRef.hide()"
        [attr.aria-label]="'Payment.close' | translate"
        class="btn btn-link"

        role="button"
        tabindex="0">
      {{ 'Payment.close' | translate }}
    </button>
    <button [attr.aria-busy]="(isLoading$ | async) ? 'true' : 'false'"
        [attr.aria-disabled]="(isLoading$ | async) ? 'true' : 'false'"
        [attr.aria-label]="'Payment.update' | translate"
        [disabled]=" (isLoading$ | async)"
        class="btn btn-primary"
        role="button"
        tabindex="0"
        type="submit">
      <ui-spinner [attr.aria-hidden]="true" [class.active]="isLoading$ | async">
        {{ 'Payment.update' | translate }}
      </ui-spinner>
    </button>
  </div>
</form>
